import React from "react";
import KC_UIText from "../../../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../../../designsystem/ds_commons";
import { tt } from "../../../../../../utils/i18n/i18n";
import KC_Checkbox from "../../../../../../designsystem/KC_FormInput/KC_Checkbox";
import KC_Button, {
  KC_ButtonSize,
  KC_ButtonType
} from "../../../../../../designsystem/KC_Button/KC_Button";

interface Props {
  hasDineInService: boolean;
  setHasDineInService: React.Dispatch<React.SetStateAction<boolean>>;
  hasDeliveryService: boolean;
  setHasDeliveryService: React.Dispatch<React.SetStateAction<boolean>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

export default function ChooseActivity(props: Props) {
  return (
    <>
      <div className="mb-5 d-flex flex-column align-items-center">
        <label className="mb-3">
          <KC_UIText
            weight={KC_Weights.md}
            text={tt("posa_form_activity_question")}
          />
        </label>
        <div className="d-flex flex-column flex-md-row" style={{ gap: "2rem" }}>
          <div
            id="dine-in-service-checkbox"
            className="d-flex align-items-center cursor-pointer"
            style={{ gap: "0.25rem" }}
            onClick={() => props.setHasDineInService((prev) => !prev)}
          >
            <KC_Checkbox checked={props.hasDineInService} />
            <KC_UIText
              weight={KC_Weights.reg}
              text={tt("posa_form_dine_in_service_question")}
            />
          </div>
          <div
            id="delivery-service-checkbox"
            className="d-flex align-items-center cursor-pointer"
            style={{ gap: "0.25rem" }}
            onClick={() => props.setHasDeliveryService((prev) => !prev)}
          >
            <KC_Checkbox checked={props.hasDeliveryService} />
            <KC_UIText
              weight={KC_Weights.reg}
              text={tt("posa_form_delivery_service_question")}
            />
          </div>
        </div>
      </div>

      <div className="mt-5">
        <KC_Button
          id="choose-activity-continue"
          size={KC_ButtonSize.Large}
          type={KC_ButtonType.Button}
          text={tt("continue")}
          onClick={() => props.setStep(1)}
          disabled={!props.hasDeliveryService && !props.hasDineInService}
          className="ml-auto"
        />
      </div>
    </>
  );
}
